import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AdminGuard({ children }: { children: ReactNode }) {
  const { user, loading, profileReady, isAdmin } = useAuth();
  const location = useLocation();

  // Se espera a que el perfil esté resuelto (una sola vez por sesión) para no
  // mostrar "Acceso restringido" a un administrador mientras su perfil carga.
  if (loading || (user && !profileReady)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-full border-2 border-primary-500 border-t-transparent animate-spin" />
          <span className="text-sm text-foreground-600">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 mx-auto rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
            <i className="ri-shield-keyhole-line text-3xl" />
          </div>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950">
            Acceso restringido
          </h1>
          <p className="mt-3 text-foreground-600 leading-relaxed">
            Esta sección es exclusiva del administrador. No tienes permisos para ver o modificar
            esta configuración.
          </p>
          <a
            href="/"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition cursor-pointer"
          >
            <i className="ri-arrow-left-line" /> Volver al inicio
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}